import { render, staticRenderFns } from "./OrderHistoryItem.vue?vue&type=template&id=2d4bf62a&"
import script from "./OrderHistoryItem.vue?vue&type=script&lang=js&"
export * from "./OrderHistoryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports